import type { VoidFunctionComponent } from 'react';
import { useLicense } from '../../../../hooks/api/licenses';
import * as Loading from './Loading';
import styles from './FileViewer.module.less';

type Props = {
  licenseId: string;
};

/**
 * FileViewerLicense displays the full title of the license
 * and the description (if available).
 */
const FileViewerLicense: VoidFunctionComponent<Props> = ({ licenseId }) => {
  const { isLoading, data: license } = useLicense(licenseId);
  return (
    <div className={styles.license}>
      {isLoading ? (
        <Loading.License />
      ) : (
        <>
          <h2 className={styles.licenseHeading}>
            {license?.name ?? licenseId}
          </h2>
          {license?.description && (
            <p className={styles.licenseDescription}>
              {license.description}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default FileViewerLicense;
